import React, { useState } from 'react';
import {
  ICommandBarItemProps,
  PrimaryButton,
  Stack,
} from '@fluentui/react';
import { commandBarTheme, commandBarThemeCounter } from '../../../theme';
import { CommandBarSticky } from '../../../components/parts';
import { BillitInvoice } from '../../billit-invoices/types';
import BillitInvoicesAssignedDetailList from './BillitInvoicesAssignedDetailList';
import BillitInvoiceAssignedDetail from './BillitInvoiceAssignedDetail';

interface Props {
  loading?: boolean;
  loadingMore?: boolean;
  invoices: BillitInvoice[];
  refetch: any;
  total: number;
  showLoadMore?: boolean;
  loadMoreCallback?: () => void;
}

const BillitInvoicesAssignedOverview = ({
  invoices,
  loading,
  loadingMore,
  refetch,
  total,
  showLoadMore = false,
  loadMoreCallback = () => {},
}: Props) => {
  const [selectedInvoice, setSelectedInvoice] = useState<BillitInvoice>();
  const [isDetailPanelOpen, setIsDetailPanelOpen] = useState(false);

  const handleSelect = (invoice: BillitInvoice) => {
    setSelectedInvoice(invoice);
    setIsDetailPanelOpen(true);
  };

  const handleDismissPanel = (closeAll?: boolean) => {
    setIsDetailPanelOpen(false);
    if (closeAll === true) {
      setSelectedInvoice(undefined);
    }
  };

  const commandBaritems: ICommandBarItemProps[] = [
    {
      key: 'totaal',
      text: `${invoices.length}/${total}`,
      theme: commandBarThemeCounter,
    },
  ];

  return (
    <>
      <CommandBarSticky
        items={commandBaritems}
        theme={commandBarTheme}
        maxWidth='2000px'
      />

      <BillitInvoicesAssignedDetailList
        items={invoices}
        enableShimmer={loading}
        onSelect={handleSelect}
        loadMore={!!loadMoreCallback}
        loadMoreCallback={loadMoreCallback}
      />

      {showLoadMore && (
        <Stack
          style={{ marginTop: '15px', marginLeft: 'auto', marginRight: 'auto' }}
          horizontal
          horizontalAlign='center'
        >
          <PrimaryButton
            text='Toon meer'
            onClick={loadMoreCallback}
            disabled={loading || loadingMore}
          />
        </Stack>
      )}

      <BillitInvoiceAssignedDetail
        isOpen={isDetailPanelOpen}
        dismissPanel={handleDismissPanel}
        invoice={selectedInvoice}
        refetch={refetch}
      />
    </>
  );
};

export default BillitInvoicesAssignedOverview;
